// Community Fixes 0710 Part 0 (SD-T690) — the ONE place the farmer app reads its Supabase address and key.
//
// Before this file every edge-function call site carried its own `import.meta.env.X || '<Live key>'`
// fallback. On the Dev preview the variable was unset, so the Dev app signed every edge call with the
// LIVE anon key and Dev functions that verify JWTs answered 401 (COMMUNITY_PRECHECKS_RESULTS §11).
// Rule (trap rule 9): no production key as a fallback; the build itself checks that the key belongs
// to the configured project (vite.config.ts → agxlSupabaseEnvCheck). At runtime this module throws
// at import if the values are missing, so a misconfigured build fails at startup, never half-works.
//
// Test runs (vitest, MODE === 'test') get inert placeholders: they must never reach a real project.

const mode = import.meta.env.MODE;
const rawUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const rawKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) as
  | string
  | undefined;

const isTest = mode === 'test';
const url = rawUrl ?? (isTest ? 'https://test-project.invalid' : undefined);
const key = rawKey ?? (isTest ? 'test-anon-key' : undefined);

if (!url || !key) {
  throw new Error(
    'Supabase environment missing: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (or VITE_SUPABASE_PUBLISHABLE_KEY) must be set at build time.',
  );
}

/** Project base URL, e.g. https://<ref>.supabase.co */
export const SUPABASE_URL: string = url;
/** The public (anon / publishable) key the browser sends as `apikey`. */
export const SUPABASE_ANON_KEY: string = key;
/** The project ref taken from the URL host; the build check asserts the key belongs to it. */
export const SUPABASE_PROJECT_REF: string = new URL(url).hostname.split('.')[0];
/** Edge function base URL. */
export const SUPABASE_FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;
